import AuthContext from "../../context/Auth/authContext";
import {
	Comment,
	Dashboard,
	Log,
	Report,
	Service,
	Task,
	Users,
} from "../../pages";
import { DecodedJWT } from "../../utils";
import { useContext, useEffect } from "react";

const usePrivillage = () => {
	const decoded = DecodedJWT();
	const authContext = useContext(AuthContext);
	const { loadUserInfo } = authContext;
	const RouteTicketing = [];

	if (decoded.dashboard_status) {
		RouteTicketing.push({
			path: "/dashboard",
			component: Dashboard,
			exact: true,
		});
	}

	if (decoded.role_master === 1) {
		RouteTicketing.push(
			{
				path: "/settings",
				component: Service,
				exact: false,
			},
			{
				path: "/users",
				component: Users,
				exact: false,
			},
			{
				path: "/log",
				component: Log,
				exact: false,
			},
			{
				path: "/task",
				component: Task,
				exact: true,
				render: true,
			},
			{
				path: "/task/:id",
				component: Comment,
				exact: false,
				render: true,
			}
		);
	}

	if (decoded.role_master === 2) {
		RouteTicketing.push(
			{
				path: "/task",
				component: Task,
				exact: true,
				render: true,
			},
			{
				path: "/task/:id",
				component: Comment,
				exact: false,
				render: true,
			}
		);
	}

	if (decoded.report_status) {
		RouteTicketing.push({
			path: "/report",
			component: Report,
			exact: false,
		});
	}

	useEffect(() => {
		loadUserInfo();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return { RouteTicketing };
};

export default usePrivillage;
